import React from "react";
import PropTypes from "prop-types";
import ContentEditorComponent from "@components/ContentEditorView/ContentEditorComponent";

const ContentEditorView = ({ content }) => {
  if (Array.isArray(content) && content.length > 0) {
    return <ContentEditorComponent content={content} />;
  }

  // No data provided
  return null;
};

ContentEditorView.propTypes = {
  content: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default ContentEditorView;
